import React from 'react';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import EmployeesAutocomplete from './employees-autocomplete/EmployeesAutocomplete.jsx';

const EmployeesField = (props) => {
  const {
    selected,
    handleSelect,
    additionalSearchParams,
    onShowManageModal,
    title,
  } = props;

  return (
    <FormGroup className="m-b-8">
      <ControlLabel>
        {title || ''}
        <strong className="bordered bordered-xs text-muted m-l-8">
          Total:&nbsp;
          <span className="text-info-brand count">{selected.length}</span>
        </strong>
        <button
          type="button"
          className="btn-clear btn-link m-l-4 m-r-40"
          onClick={() => onShowManageModal()}
        >
          Manage
        </button>
      </ControlLabel>
      <EmployeesAutocomplete
        additionalSearchParams={additionalSearchParams}
        isItemActive={(val) => selected.includes(val)}
        handleSelect={handleSelect}
      />
    </FormGroup>
  );
};
export default EmployeesField;
